export default "__VITE_ASSET__DVy7Wvsg__"